import { expand } from 'uri-template-lite';
import { apiClient } from '../../../common/ApiClient';
import { createApiMutationHook } from '../../../common/queryClient/createApiMutationHook';
import { SampleEditSessionUrl } from '../SampleEditSessionUrl';

const commitSampleDrafts = async (params: { sessionId: string }) =>
  apiClient
    .post(expand(SampleEditSessionUrl.commit, params))
    .then((response) => response.data);

export const useCommitSampleDraftsMutation = createApiMutationHook(
  ['sample-drafts-commit'],
  commitSampleDrafts,
);
